import { gql } from '@apollo/client'
import { mutate } from 'shared/helpers/graphql'

export async function upsertLevel(payload) {
  return mutate(
    {
      unitTypeLevels: [payload],
    },
    gql`
      mutation Upsert_unit_type_levels($unitTypeLevels: [unit_type_levels_input]) {
        upsert_unit_type_levels(unit_type_levels: $unitTypeLevels) {
          id
        }
      }
    `,
  )
}

export async function deleteLevel(id) {
  return mutate(
    {
      "deleteUnitTypeLevelsId": id
    },
    gql`
      mutation Delete_unit_type_levels($deleteUnitTypeLevelsId: Int!) {
  delete_unit_type_levels(id: $deleteUnitTypeLevelsId) {
    id
  }
}
    `,
  )
}
